module.exports = __webpack_public_path__ + "static/peffers-hex-6d701c68e15515d7cb7b1ac77651f485.png";